









































































































































































































// we must import our Modal plugin instance
// because it contains reference to our Eventbus
import productApi from "@/api/productApi";
import CustomerUser from "@/model/customerUser";
import Product, { SaleBoom } from "@/model/product";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import anime from "animejs";
import qNotify from "./qNotify";
import QErrors from "@/common/qErrors.vue";
import { ADMIN_TYPE, MAX_PRICE } from "./constant";

const authStore = namespace("Auth");
const cartStore = namespace("Cart");
@Component({
  name: "qProductPopup",
  components: {
    QErrors,
  },
})
export default class qProductPopup extends Vue {
  public isShow = false;
  public product: Product = new Product();
  public saleBoms: SaleBoom[] = [];
  public errors: any = {};
  public classError = "AttentionBalloon";
  public isMaxPriceError = false;

  @authStore.Getter
  public getCustomerUser!: CustomerUser;

  @cartStore.Action
  public addCart!: (product) => void;

  @authStore.Getter
  getUserType!: string;

  @cartStore.Getter
  cartItems!: any[];

  @cartStore.Getter
  isLimitAddCart!: boolean;

  get isCustomer() {
    return this.getUserType != ADMIN_TYPE;
  }

  show(product: any) {
    this.isShow = true;
    this.loadDetail(product.item_code);
  }

  async loadDetail(itemCode) {
    const loader = Vue.$loading.show({});
    const requests: any = [
      productApi.getDetail(itemCode),
      productApi.getSaleBom(itemCode),
    ];
    const result: any = await Promise.all(requests);
    loader.hide();
    result[0] && (this.product = result[0]);
    result[1] && (this.saleBoms = result[1]);

  }

  checkQuantity() {
    // check input correct quanlity;
    let saleBomIndexs = [];
    let saleBomIndexTotal = 0;
    this.saleBoms.map((item, index) => {
      if (!item.cart_quanlity) {
        saleBomIndexs.push(index);
      }
      saleBomIndexTotal++;
    });

    if (
      saleBomIndexs.length != saleBomIndexTotal ||
      (this.product.cart_quanlity && this.product.cart_quanlity > 0)
    ) {
      return true;
    } else {
      qNotify.error({
        text: this.$t("cart_page.messsage.empty_cart"),
      });

      if (!this.product.cart_quanlity) {
        this.errors = {
          ...this.errors,
          ...{
            [`cart.0.product_quantity`]: [
              this.$t("cart_page.messsage.quantity_is_required"),
            ],
          },
        };
      }
      if (saleBomIndexs.length == saleBomIndexTotal) {
        saleBomIndexs.map((saleBomIndex) => {
          this.errors = {
            ...this.errors,
            ...{
              [`cart.${saleBomIndex}.product_quantity`]: [
                this.$t("cart_page.messsage.quantity_is_required"),
              ],
            },
          };
        });
      }

      return false;
    }
  }

  async addToCart() {
    if (!this.checkQuantity()) {
      return;
    }
    if (!this.isMaxPriceError) {
      this.errors = {}
    }
    
    if (!this.canProcess()) {
      return;
    }
    let items: any[] = this.saleBoms;
    if (this.product) {
      items.unshift(this.product);
    }
    try {
      await this.addCart(items);
    } catch (error) {
      console.log("error", error);
      qNotify.error({
        text: error,
      });
    }
    const cartIcon = document.querySelector("#Cart");
    const { x, y } = cartIcon.getBoundingClientRect();
    // const targets = "body .ProdDetailPopup",
    const node = document.querySelector("#popupProduct");
    const nodeProduct = document.querySelector(".productImage");
    const clone: any = nodeProduct.cloneNode(true);
    const styles = [
      "position:absolute",
      "opacity: 0.8",
      `left:${nodeProduct.getBoundingClientRect().x}px`,
      `top:${window.pageYOffset + node.getBoundingClientRect().y}px`,
      `width: ${nodeProduct.clientWidth}px`,
      `border: 5px solid #ccc`,
    ];

    clone.style = styles.join(";");
    document.querySelector("body").append(clone);

    anime({
      targets: ".productImage",
      easing: "easeInOutSine",
      top: [
        { value: window.pageYOffset + y + 50, duration: 800, delay: 300 },
        { value: window.pageYOffset + y - 200, duration: 1000, delay: 200 },
      ],
      left: [
        { value: x - nodeProduct.clientWidth / 4, duration: 800, delay: 300 },
      ],
      scale: {
        value: 0,
        duration: 1000,
        delay: 1100,
        easing: "easeInOutQuart",
      },
      // left: `${y}px`,
      // top: `${x}px`,
      delay: 200,

      complete: () => {
        setTimeout(() => {
          anime({
            targets: "#Cart",
            translateX: [
              { value: 10, duration: 50 },
              { value: -10, duration: 50 },
              { value: 10, duration: 50 },
              { value: -10, duration: 50 },
              { value: 10, duration: 50 },
              { value: -10, duration: 50 },
              { value: 0, duration: 50 },
            ],
          });
        });

        clone.remove();
      },
    });

    this.isShow = false;
  }

  public async addToOrder() {
    if (!this.canProcess()) {
      return;
    }
    let items: any[] = this.saleBoms.filter((item) => item.cart_quanlity > 0);
    if (this.product.cart_quanlity > 0) {
      items.unshift(this.product);
    }

    try {
      await this.addCart(items);
      this.$router.push({ name: "customer.order" });
    } catch (error) {
      console.log("error", error);
      qNotify.error({
        text: error,
      });
    }
  }

  public canProcess() {
    let flag = 0;
    for (let key of Object.keys(this.errors)) {
      if (this.errors[key].length > 0) {
        flag++;
      }
    }

    if (flag > 0) {
      qNotify.error({
        text: this.$t("cart_page.validate.max_price"),
      });
    }

    return flag === 0;
  }

  public handleChangeBoomQuantity(item: any, index: number, key) {
    const total = this.cartItems
      .filter(
        (cart) =>
          cart.set_item_code === item.set_item_code &&
          cart.item_code === item.item_code
      )
      /* eslint-disable unicorn/no-array-reduce */
      .reduce((memo, cart) => {
        return cart.cart_quanlity * item.price + memo;
      }, 0) + item.total;
    // group prod to sum
    if (total > MAX_PRICE) {
      this.isMaxPriceError = true;
      this.errors = {
        ...this.errors,
        ...{
          [`cart.${index}.${key}`]: [this.$t("cart_page.validate.max_price")],
        },
      };
    } else {
      this.errors = {
        ...this.errors,
        ...{ [`cart.${index}.${key}`]: [] },
      };
    }
  }
}
